import { render, staticRenderFns } from "./FlatRentBuy.vue?vue&type=template&id=68cfccaf"
import script from "./FlatRentBuy.vue?vue&type=script&setup=true&lang=ts"
export * from "./FlatRentBuy.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports